import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuantumComputingComponent } from './quantum-computing.component';

const routes: Routes = [
  {
      path: '',
      component: QuantumComputingComponent 
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuantumComputingRoutingModule { }
